export default __webpack_public_path__ + "static/media/Delete icon color 0E9FA3.9a17c01e.svg";